// @ts-ignore
import { helpers } from '../../helpers';
import { Team } from '@/types/teams';
export default {
    set(storestate, { teams, state }) {
        for (const team of teams) {
            if (team.schedule === undefined)
                team.schedule = [];
        }
        const teamClasses = teams.map(team => Team.load(team));
        // @ts-ignore
        helpers.updateStateToObject(storestate[state], teamClasses, 'id');
    },
    update(state, team) {
        Object.entries(state).forEach(([_, teamstate]) => {
            if (teamstate[team.id]) {
                // @ts-ignore
                teamstate[team.id] = Team.load({ ...teamstate[team.id], ...team });
                const currentTeamState = teamstate[team.id];
                if (currentTeamState === undefined) {
                    console.error('store:team:update -> currentTeamState is undefined');
                    return;
                }
            }
        });
    },
    setDataReceived(state, status) {
        state.dataReceived[status] = true;
    },
    delete(state, id) {
        Object.values(state).forEach(teamstate => {
            if (teamstate[id]) {
                delete teamstate[id]; // TOMC: REACTIVE
            }
        });
    }
};
